export const variables = {
  primaryColor: "#7B67FD",
};
